module.exports = __webpack_public_path__ + "static/media/EAI-05.1ccac1cc.jpg";